import * as yup from 'yup';

export const schoolConfigValidationSchema = yup.object().shape({
  school: yup.string(),
  isOnboarded: yup.boolean(),
  orgCode: yup.string().required('Organization code is required'),
  timezoneDetails: yup
    .object()
    .shape({
      timezone: yup.string().required(),
      offset: yup.number().required()
    })
    .required(),
  studentEmaildDomain: yup
    .string()
    .matches(/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/, 'Enter a valid domain')
    .required('Student Email Domain is required'),
  schoolInfo: yup.array().of(
    yup.object().shape({
      name: yup.string().required('School Name is required'),
      emailIds: yup
        .array()
        .of(
          yup
            .string()
            .matches(
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              'Enter a valid email address.'
            )
        )
    })
  ),
  functionalUserEmails: yup.object().shape({
    originalPosterForPaymentPosts: yup
      .object()
      .test('validate-keys-and-values', function (value) {
        if (!value) return true; // optional

        const { path, createError } = this;

        for (const [key, val] of Object.entries(value)) {
          // ❌ Key validation (must NOT look like email in your case?)
          if (!key || typeof key !== 'string') {
            return createError({
              path: `${path}.${key || 'key'}`,
              message: 'Invalid section key'
            });
          }

          // ❌ Value validation (must be a valid email)
          if (
            typeof val !== 'string' ||
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)
          ) {
            return createError({
              path: `${path}.${key}`,
              message: `Invalid email for section "${key}"`
            });
          }
        }
        return true;
      })
      .notRequired(),
    accountsEmail: yup
      .string()
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Enter a valid email address.'),
    welcomeEmailId: yup
      .string()
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Enter a valid email address.'),
    grooveHqEmailId: yup
      .string()
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Enter a valid email address.')
  }),
  welcomeEmailNotificationsConfig: yup.object().shape({
    admissionOfferValidityDays: yup
      .string()
      .required('Admission Offer Validity Days is required'),
    brandName: yup.string().required('Brand name is required'),
    brandSignOffLine: yup
      .string()
      .required('Brand sign off line Days is required'),
    fullFeeConcession: yup.string().required('Full fee concession is required'),
    knowlarityNumber: yup.string().required('Knowlarity number is required'),
    schoolFullName: yup.string().required('School Full name is required')
  })
});
